<template>
  <div :style="{direction:$t('direction')}" class="site-wrapper">

    <Header></Header>
    
    <div class="my-5 pt-3" id="aboutus">
    </div>
    
    <div class="aboutus-wrapper">
        <div class="aboutus-inner">

            <h1 id="">درباره ما</h1>

            <div v-html="state_setting.about_us_text"></div>
        </div>
    </div>  

    <div class="my-5 pt-3" id="rules"></div>
    <div class="aboutus-wrapper">
        <div class="aboutus-inner" v-html="state_setting.rules_text">
            
        </div>
    </div>

    <div class="my-5 pt-3" id="contactUs"></div>
    <div class="aboutus-wrapper">
        <div class="aboutus-inner" v-html="state_setting.contact_us_text">
            
        </div>
    </div>
    
    
    <div class="faq" id="faq">
    </div>
    <div class="faq-content">
      <!-- <div class="faq-inner">
        <div class="row faq-in">
          <div class="col-md-6 px-5">
            لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیهدر همان حال کار آنها به نوعی وابسته 
          </div>
          <div class="col-md-6">
            <div class="faq-banner">
              <img :src="StaticImageUrl+'assets/images/bitcoin-trading.png'" alt="">
            </div>
          </div>
        </div>
      </div> -->

      <div style="color:#fff;" class="faq-title">
        سوالات متداول
      </div>

      <div class="qustions-wrapper">
        
        <vsa-list>
          <vsa-item>
            <vsa-heading>
              احراز هویت چیست و چرا انجام می شود؟
            </vsa-heading>
        
            <vsa-content>
              احراز هویت فرایندی ضروری برای امنیت شما عزیزان و مجموعه ی ارزینه است که شامل ارسال مدارک، و تایید حساب های بانکی، و به منظور جلوگیری از بروز مشکلاتی از جمله پولشویی، کلاهبرداری، و ... انجام می شود.
            </vsa-content>
          </vsa-item>
          
          <vsa-item>
            <vsa-heading>
              برای چه کاری احراز هویت نیاز دارم؟
            </vsa-heading>
        
            <vsa-content>
              برای خرید ارز از ما نیاز به تکمیل مراحل احراز هویت دارید.
            </vsa-content>
          </vsa-item>
          
          <vsa-item>
            <vsa-heading>
              چطور میتونم با ارزینه خرید و فروش ارز داشته باشم؟
            </vsa-heading>
        
            <vsa-content>
              برای مشاهده ی آموزش تصویری خرید و فروش ارز، به <a href="https://arzine.org/Article/TradeTutorial" target="_blank">این مقاله</a> مراجعه کنید.
            </vsa-content>
          </vsa-item>
          
          <vsa-item>
            <vsa-heading>
              چه ارز هایی را میتوانم خرید و فروش کنم؟
            </vsa-heading>
        
            <vsa-content>
              ارزینه در زمینه ی خرید و فروش و تبدیل کلیه ارز های لیست شده در Binance فعالیت میکند. برای مشاهده ی لیست ارز های قابل خرید و فروش از مجموعه ی ما، و مشاهده ی قیمت "حدودی" ارز ها به بخش قیمت لحظه ای وبسایت ما مراجعه کنید.
              <a href="https://arzine.org/RealTimePrice" target="_blank">https://arzine.org/RealTimePrice</a>
            </vsa-content>
          </vsa-item>
          
          <vsa-item>
            <vsa-heading>
              چطور میتونم کیف پول بسازم؟
            </vsa-heading>
        
            <vsa-content>
              از معتبر ترین و امن ترین کیف پول های ارز دیجیتال میتوان از Trust Wallet و Coin98 نام برد. با مراجعه به <a href="https://arzine.org/Article/CryptoWallets" target="_blank">این مقاله</a> آموزش ساخت این کیف پول ها را مطالعه کنید.
            </vsa-content>
          </vsa-item>
          
          <vsa-item>
            <vsa-heading>
              ارز دیجیتال چیست؟
            </vsa-heading>
        
            <vsa-content>
              ارز دیجیتال (Cryptocurrency) شکل خاصی از پول دیجیتال است که بر پایه علم رمزنگاری ایجاد شده است. بیشتر ارزهای دیجیتال برای بهره‌مند شدن از ویژگی‌های اساسی مانند غیرمتمرکز بودن، شفافیت و تغییرناپذیر بودن از بلاک چین استفاده می‌کنند.
              ماهیت غیرمتمرکز ارزهای دیجیتال به این معنی است که هیچ نهاد، گروه یا سازمانی آن‌ها را کنترل نمی‌کند.
              کریپتوکارنسی‌ها را می‌توان به صورت مستقیم و بدون دخالت هرگونه واسطه‌ای در اینترنت به شخص دیگری ارسال کرد. یعنی برای ارسال ارزهای دیجیتال به یکدیگر نیازی به افتتاح حساب بانکی، استفاده از خدمات بانک‌ها یا هر سازمان واسطه‌ دیگری نخواهید داشت.
              رمزارزها همانند ریال و دلار پول‌هایی هستند که با سازوکار مختلفی ایجاد و توزیع می‌شوند. فرایند خلق برخی از این پول‌ها مانند بیت کوین با ماینینگ انجام می‌شود و برای تعدادی دیگر از آن‌ها، تمامی سکه‌ها از قبل به صورت استخراج شده در شبکه قرار می‌گیرند.
            </vsa-content>
          </vsa-item>
          
          <vsa-item>
            <vsa-heading>
              بیت کوین چیست؟
            </vsa-heading>
        
            <vsa-content>
              برای مطالعه ی مقاله ی ما درباره ی بیت کوین و دلیل ارزشمند بودن آن به <a href="https://arzine.org/Article/WhatIsBitcoin" target="_blank">این لینک</a> مراجعه کنید.
            </vsa-content>
          </vsa-item>
          
          <vsa-item>
            <vsa-heading>
              تتر چیست؟
            </vsa-heading>
        
            <vsa-content>
              تتر(USDT)، یک رمزارزپایه ثابت است که پشتوانه آن همواره یک دلار است. تتر به علت این‌که ارز پایه است، امکان تبدیل آن به سایر ارزهای دیجیتال وجود دارد. ارزش تتر ثابت است و به‌عنوان امن‌ترین گزینه برای ورود به دنیای ارزهای دیجیتال شناخته می‌شود.
            </vsa-content>
          </vsa-item>
          
          <vsa-item>
            <vsa-heading>
              شبکه های ERC-20 و TRC-20 چه فرقی دارند؟
            </vsa-heading>
        
            <vsa-content>
              ارز هایی که مثل تتر (USDT) توکن هستند و شبکه ی مخصوص خود را ندارند، از شبکه ی ارز های دیگر مثل شبکه ی بیت کوین، اتریوم، بایننس کوین، و ترون استفاده می کنند.
              برای مطالعه ی اطلاعات دقیق تر راجع به شبکه های انتقال، <a href="https://arzine.org/Article/Chains" target="_blank">این مقاله</a> را مطالعه کنید.
            </vsa-content>
          </vsa-item>
          
        </vsa-list>

      </div>


    </div>

    <div class="my-5 pt-3" id="earning"></div>
    <div class="aboutus-wrapper">
        <div class="aboutus-inner" v-html="state_setting.earning_text">
            
        </div>
    </div>

    <Footer></Footer>
    

  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
export default {
  name: 'AboutUs',
  components:{
    Header,
    Footer
  },
  data : () => ({
    
  }),
  watch: { 
    '$route.query.section': {
      handler: function(section) {
        this.deepScrollTo(section)
      },
      deep: true,
      immediate: true
    }
  },
  methods: { 
    deepScrollTo(section)
    {
      if(!section){
        return;
      }
      const el = document.getElementById(section);
      if(el)
      {
        el.scrollIntoView();
      }
    }
  },
  mounted(){
    this.activeLoading(false)
    const section = this.$route.query.section;
    if(section){
      this.deepScrollTo(section)
    }
  }
}
</script>
<style scoped>
.spacer-about{
    height: 100px;
    width: 100%;
}
.aboutus-wrapper{
    padding: 40px 70px;
}
.aboutus-wrapper .aboutus-inner{
    padding: 40px;
    border-radius: 20px;
    background: var(--theme2);
    color: #fff !important;
}
@media (max-width: 576px) {

  .aboutus-wrapper{
      padding: 10px 10px !important;
  }
  .aboutus-wrapper .aboutus-inner{
      padding: 10px 20px !important;
      border-radius: 10px !important;
  }

}
</style>